// import external modules
import React, { Component } from "react"
import { Link, withRouter } from "react-router-dom"
import {
   Form,
   Collapse,
   Navbar,
   Nav,
   NavItem,
   UncontrolledDropdown,
   DropdownToggle,
   DropdownMenu,
   DropdownItem
} from "reactstrap";
import {
   Mail,
   Menu,
   MoreVertical,
   User,
   LogOut
} from "react-feather";
import NavbarSearch from "../../../components/search/Search";
import ReactCountryFlag from "react-country-flag";
import axios from 'axios'
const cookie = require('js-cookie')
class ThemeNavbar extends Component {
   handleClick = e => {
      this.props.toggleSidebarMenu("open");
   };
   constructor(props) {
      super(props);
      
      this.toggle = this.toggle.bind(this);
      this.logout = this.logout.bind(this)
      this.state = {
         isOpen: false,
         loading: true,
         user: {}
      };
   }
   toggle() {
      this.setState({
         isOpen: !this.state.isOpen
      });
   }
   logout() {
      cookie.remove('token')
      this.props.history.push('/login')
   }

   componentDidMount() {
      this.loadUser()
   }

   async loadUser() {
      const token = cookie.get('token')
      const res = await axios.get('/api/profile', {
         headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
         }
      })
      let user
      if (res.data) user = res.data 
      this.setState({user: user, loading: false})
   }

   renderProfile() {
      const { user } = this.state
      return (
         this.state.loading ? <span>Loading ...</span> : 
            <>
               <span className="mr-2">{`${this.state.user.firstname} ${this.state.user.lastname}`}</span>
               <img 
                  src={user.avatar === null ? '/default-avatar.png' : user.avatar} 
                  alt="logged-in-user" 
                  className="rounded-circle width-35 height-35" 
                  style={{
                        objectFit: 'contain'
                  }}
               />
            </>
      )
   }

   render() {
      return (
         <Navbar className="navbar navbar-expand-lg navbar-light bg-faded">
            <div className="container-fluid px-0">
               <div className="navbar-header">
                  <Menu
                     size={14}
                     className="navbar-toggle d-lg-none float-left"
                     onClick={this.handleClick.bind(this)}
                     data-toggle="collapse"
                  />
                  <MoreVertical
                     className="mt-1 navbar-toggler black no-border float-right"
                     size={50}
                     onClick={this.toggle}
                  />
               </div>
               <div className="navbar-container">
                  <Collapse isOpen={this.state.isOpen} navbar>
                     <Nav className="ml-auto float-right" navbar>
                        <UncontrolledDropdown nav inNavbar className="pr-1">
                           <DropdownToggle nav>
                              {this.renderProfile()}
                           </DropdownToggle>
                           <DropdownMenu right>
                              <Link to={`/users/view/${this.state.user.id}`} className="p-0">
                                 <DropdownItem>
                                    <span className="font-small-3">
                                       {this.state.loading ? '' : this.state.user.username}
                                    </span>
                                 </DropdownItem>
                              </Link>
                              <DropdownItem divider />

                              <Link to={`/changePassword?id=${this.state.user.id}`} className="p-0">
                                 <DropdownItem>
                                    <User size={16} className="mr-1" /> Change Password
                                 </DropdownItem>
                              </Link>
                              <DropdownItem onClick={this.logout}>
                                 <LogOut size={16} className="mr-1" /> Logout
                              </DropdownItem>
                           </DropdownMenu>
                        </UncontrolledDropdown>
                     </Nav>
                  </Collapse>
               </div>
            </div>
         </Navbar>
      );
   }
}

export default withRouter(ThemeNavbar);
